import React, { useState } from "react";
import { IIdleTimer, IIdleTimerProps, useIdleTimer } from "react-idle-timer";

export interface IUseIdleParams extends Pick<IIdleTimerProps, 'throttle' | 'onAction'> {
  onIdle: () => void;
  onPrompt: () => void;
  idleTime: number;
  promptTime: number;
}

export interface IUseIdleReturn extends Pick<IIdleTimer, 'getRemainingTime' | 'getLastActiveTime' | 'isPrompted'> {
  reset: () => void;
  isIdle: boolean;
}

function useIdle(params: IUseIdleParams): IUseIdleReturn {
  const { onIdle, onPrompt, idleTime, promptTime, ...props } = params;
  const [isIdle, setIsIdle] = useState<boolean>(false);

  const handleOnIdle = (event?: Event, idleTimer?: IIdleTimer) => {
    setIsIdle(true);
    onIdle();
  };

  const handleOnPrompt = (event?: Event, idleTimer?: IIdleTimer) => {
    onPrompt()
  }

  const { getRemainingTime, getLastActiveTime, reset, isPrompted } = useIdleTimer({
    timeout: 1000 * idleTime,
    onIdle: handleOnIdle,
    promptBeforeIdle: 1000 * promptTime,
    onPrompt: handleOnPrompt,
    ...props,
  });

  const handleOnResetIdle = () => {
    setIsIdle(false);
    reset()
  }

  return {
    getRemainingTime,
    getLastActiveTime,
    reset: handleOnResetIdle,
    isIdle,
    isPrompted
  };
}

export default useIdle;